import { _addEventListener, } from '../util/dom';
const _keyHandlers = {}, _addKeyHandlers = (keyOrKeys, handler) => {
    if (Array.isArray(keyOrKeys)) {
        for (const key of keyOrKeys) {
            _keyHandlers[key] = handler;
        }
    }
    else {
        _keyHandlers[keyOrKeys] = handler;
    }
}, _handleKeyup = (keyupEvent) => {
    const handle = _keyHandlers[keyupEvent.key];
    if (!handle) {
        return;
    }
    handle(keyupEvent);
};
_addEventListener(document, 'keyup', _handleKeyup);
export { _addKeyHandlers, };
